module.exports = __webpack_public_path__ + "img/nav-icon-command_2x.8b3d3aae.svg";